import { FilterType } from "src/api/types";
import PharmacyFilter from "src/components/PharmacyFilter";
import ProductFilter from "src/components/ProductFilter";
import {
  BILLING_MODE,
  PHARMACY,
  PRODUCT,
  STATUS,
} from "src/constants/searchParams";

export const filters: FilterType[] = [
  {
    name: STATUS,
    placeholder: "Status",
    type: "select",
    values: [
      "canceled",
      "created",
      "delivered",
      "finalized",
      "paid",
      "sent_to_pharmacy",
      "shipped",
      "unpaid",
    ],
  },
  {
    name: BILLING_MODE,
    placeholder: "Billing",
    type: "select",
    values: ["subscription", "one_time"],
  },
  {
    name: PHARMACY,
    placeholder: "Pharmacy",
    type: "custom",
    component: PharmacyFilter,
  },
  {
    name: PRODUCT,
    placeholder: "Product",
    type: "custom",
    component: ProductFilter,
  },
];
